<script lang="ts">
  import { currentRoute, productsStore, ordersStore } from "../store";

  function navigate(route: string, e: Event): void {
    e.preventDefault();
    $currentRoute = route;
  }
</script>

<div class="w-full">
  <!-- Hero Section -->
  <div
    class="relative bg-sky-600 w-full min-h-[550px] flex items-center justify-center text-center text-white px-6 py-12 overflow-hidden shadow-inner"
  >
    <div
      class="absolute inset-0 bg-cover bg-center opacity-30"
      style="background-image: url('https://plus.unsplash.com/premium_photo-1677995700941-100976883af7?q=80&w=1523&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D');"
    ></div>
    <div
      class="absolute inset-0 bg-gradient-to-t from-sky-900/80 to-transparent"
    ></div>
    <div class="relative z-10 max-w-4xl">
      <h1
        class="text-6xl md:text-8xl font-extrabold uppercase tracking-widest mb-6 drop-shadow-2xl text-amber-400"
      >
        Global Bazar
      </h1>
      <p
        class="text-xl md:text-3xl mb-10 font-medium drop-shadow-lg text-sky-50"
      >
        Unleashing premium quality products to your doorstep. Experience modern
        shopping redefined.
      </p>
      <button
        on:click={(e) => navigate("Products", e)}
        class="bg-amber-400 text-black font-black uppercase tracking-widest py-4 px-12 rounded-full hover:bg-white hover:text-sky-600 transition duration-300 shadow-2xl hover:shadow-white/20 hover:scale-110"
        >Shop Now</button
      >
    </div>
  </div>

  <!-- Stats Section -->
  <div class="max-w-7xl mx-auto px-6 py-20">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-10 text-center">
      <div
        class="bg-white p-10 rounded-3xl shadow-xl border-t-8 border-sky-400 hover:-translate-y-3 transition duration-400 flex flex-col items-center"
      >
        <div
          class="text-sky-500 mb-6 text-6xl bg-sky-50 w-24 h-24 flex items-center justify-center rounded-full"
        >
          <i class="fa-solid fa-box-open"></i>
        </div>
        <h3 class="text-6xl font-black text-gray-800 mb-3">
          {$productsStore.length}+
        </h3>
        <p class="text-gray-500 text-xl uppercase tracking-widest font-bold">
          Premium Products
        </p>
      </div>
      <div
        class="bg-white p-10 rounded-3xl shadow-xl border-t-8 border-amber-400 hover:-translate-y-3 transition duration-400 flex flex-col items-center"
      >
        <div
          class="text-amber-500 mb-6 text-6xl bg-amber-50 w-24 h-24 flex items-center justify-center rounded-full"
        >
          <i class="fa-solid fa-truck-fast"></i>
        </div>
        <h3 class="text-6xl font-black text-gray-800 mb-3">
          {$ordersStore.length}+
        </h3>
        <p class="text-gray-500 text-xl uppercase tracking-widest font-bold">
          Orders Delivered
        </p>
      </div>
      <div
        class="bg-white p-10 rounded-3xl shadow-xl border-t-8 border-green-400 hover:-translate-y-3 transition duration-400 flex flex-col items-center"
      >
        <div
          class="text-green-500 mb-6 text-6xl bg-green-50 w-24 h-24 flex items-center justify-center rounded-full"
        >
          <i class="fa-solid fa-users"></i>
        </div>
        <h3 class="text-6xl font-black text-gray-800 mb-3">99%</h3>
        <p class="text-gray-500 text-xl uppercase tracking-widest font-bold">
          Customer Satisfaction
        </p>
      </div>
    </div>
  </div>

  <!-- Call to action block -->
  <div class="bg-gray-100 py-20 px-6 text-center shadow-inner">
    <h2 class="text-5xl font-black mb-6 text-gray-800 uppercase tracking-tight">
      Need Assistance?
    </h2>
    <p class="text-xl text-gray-600 mb-10 max-w-3xl mx-auto font-medium">
      Our support team is available 24/7 to resolve any queries and ensure a
      smooth, secure shopping experience for you.
    </p>
    <button
      on:click={(e) => navigate("Contact Us", e)}
      class="bg-sky-500 text-white font-black py-4 px-10 rounded-xl hover:bg-amber-400 hover:text-black transition duration-300 shadow-xl hover:shadow-2xl hover:-translate-y-2 uppercase tracking-widest text-lg"
      >Contact Us Today</button
    >
  </div>
</div>
